<template>
  <v-flex>
    <v-dialog v-model="generating" persistent width="300">
      <v-card color="#f8ac4a" dark>
        <v-card-text>
          A gerar pdf. Por favor aguarde...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="waiting" persistent width="300">
      <v-card color="#f8ac4a" dark>
        <v-card-text>
          A carregar. Por favor aguarde.
          <v-progress-linear
            color="white"
            v-model="exportingProgress"
            height="25"
          >
            <div class="d-flex justify-center black--text">
              {{
                Math.ceil(exportingProgress > 100 ? 100 : exportingProgress)
              }}%
            </div>
          </v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="mb-4">
      <v-flex xs12 sm12 md12>
        <v-card style="box-shadow: none; background-color: #f8f8f8">
          <v-container grid-list-md style="padding: 0 !important">
            <v-flex xs12 sm12 md12>
              <v-layout wrap>
                <v-flex xs3 sm3 md3>
                  <label class="label-modal">Objetivo</label>
                  <v-autocomplete
                    color="#f8ac4a"
                    :items="getObjetivos"
                    v-model="FILTRO.id_objetivo"
                    item-text="nome"
                    item-value="id_objetivo"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs3 sm3 md3>
                  <label class="label-modal">Medida</label>
                  <v-autocomplete
                    color="#f8ac4a"
                    :items="getMedidasByObjetivo(FILTRO.id_objetivo)"
                    v-model="FILTRO.id_medida"
                    item-text="nome"
                    item-value="id_medida"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs3 sm3 md3>
                  <label class="label-modal">Ação</label>
                  <v-autocomplete
                    color="#f8ac4a"
                    :items="getAcoesByMedida(FILTRO.id_medida)"
                    v-model="FILTRO.id_acao"
                    item-text="nome"
                    item-value="id_acao"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs3 sm3 md3></v-flex>
                <v-flex xs3 sm3 md3>
                  <label class="label-modal">Instituição</label>
                  <v-autocomplete
                    color="#f8ac4a"
                    :items="getAllInstituicoes"
                    v-model="FILTRO.id_instituicao"
                    item-text="nome"
                    item-value="id_instituicao"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs3 sm3 md3>
                  <label class="label-modal">Ano</label>
                  <v-autocomplete
                    color="#f8ac4a"
                    :items="getAnos"
                    v-model="FILTRO.id_ano"
                    item-text="nome"
                    item-value="id_ano"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs3 sm3 md3 style="display: flex; align-items: center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        color="#f8ac4a"
                        fab
                        dark
                        small
                        @click="filtrar()"
                      >
                        <v-icon>search</v-icon>
                      </v-btn>
                    </template>
                    <span>Filtrar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        color="#ff4b4b"
                        fab
                        dark
                        small
                        @click="limpar()"
                      >
                        <v-icon>clear</v-icon>
                      </v-btn>
                    </template>
                    <span>Limpar filtros</span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs3 sm3 md3></v-flex>
              </v-layout>
            </v-flex>
          </v-container>
        </v-card>
      </v-flex>
    </div>

    <div class="elevation-3">
      <v-dialog v-model="reporteM" max-width="1000px" persistent>
        <v-card>
          <v-card-title> <span class="headline">Reporte</span> </v-card-title>
          <v-card-text>
            <v-container grid-list-md style="padding: 0 !important">
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-form ref="formReporte" v-on:submit.prevent>
                    <v-stepper
                      style="box-shadow: none"
                      v-if="reporteM"
                      v-model="stepper"
                      vertical
                    >
                      <template v-for="(p, k) in formulario">
                        <v-stepper-step
                          :key="'k' + k"
                          :step="k + 1"
                          editable
                          :complete="checkedPerguntaCompleted(p)"
                          :edit-icon="'done'"
                          color="#f8ac4a"
                        >
                          {{ getDimensaoById(p.key).nome }}
                        </v-stepper-step>
                        <v-stepper-content
                          style="padding-top: 5px !important"
                          class="formulario"
                          v-for="(p, j) in p.children"
                          :key="'s' + j + k"
                          :step="k + 1"
                        >
                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap align-center>
                              <v-flex
                                xs12
                                sm12
                                md12
                                style="display: grid !important"
                              >
                                <label class="label-pergunta"
                                  ><v-icon color="#222222" size="20"
                                    >arrow_right</v-icon
                                  >
                                  {{ p.pergunta.nome }}</label
                                >
                                <label class="label-modal"
                                  >{{ getLegenda(p.pergunta.id_tipo) }}
                                  <span
                                    v-if="
                                      p.pergunta.required &&
                                        p.pergunta.id_tipo != 5
                                    "
                                    style="
                                      color: red !important;
                                      margin-left: 10px !important;
                                    "
                                    >* Obrigatória</span
                                  ></label
                                >
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md12
                            v-if="p.pergunta.children.length > 0"
                          >
                            <v-flex
                              xs12
                              sm12
                              md12
                              v-if="
                                p.pergunta.id_tipo == 1 ||
                                  p.pergunta.id_tipo == 2
                              "
                            >
                              <v-flex
                                xs12
                                sm12
                                md12
                                v-for="(child, i) in p.pergunta.children"
                                :key="i"
                              >
                                <v-layout row wrap align-center>
                                  <v-flex xs12 sm12 md12>
                                    <v-layout row wrap align-center>
                                      <v-flex
                                        xs12
                                        sm12
                                        md12
                                        v-if="p.pergunta.id_tipo == 1"
                                      >
                                        <v-checkbox
                                          :disabled="true"
                                          color="#f8ac4a"
                                          @change="
                                            changeCheck(p.pergunta, child, 1)
                                          "
                                          v-model="child.checked"
                                          :label="child.nome"
                                        ></v-checkbox>
                                        <v-flex
                                          xs12
                                          sm12
                                          md12
                                          v-if="
                                            child.expansivel && child.checked
                                          "
                                        >
                                          <v-flex
                                            xs12
                                            sm12
                                            md12
                                            v-for="(cc, kk) in child.children"
                                            :key="kk"
                                          >
                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="child.id_tipo == 1"
                                            >
                                              <v-checkbox
                                                :disabled="true"
                                                color="#f8ac4a"
                                                @change="
                                                  changeCheck(child, cc, 1)
                                                "
                                                v-model="cc.checked"
                                                :label="cc.nome"
                                              ></v-checkbox>
                                              <v-flex
                                                xs12
                                                sm12
                                                md12
                                                v-if="
                                                  cc.expansivel && cc.checked
                                                "
                                              >
                                                <v-flex
                                                  xs12
                                                  sm12
                                                  md12
                                                  v-for="(n, k1) in cc.children"
                                                  :key="k1"
                                                >
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 1"
                                                  >
                                                    <v-checkbox
                                                      :disabled="true"
                                                      color="#f8ac4a"
                                                      @change="
                                                        changeCheck(cc, n, 1)
                                                      "
                                                      v-model="n.checked"
                                                      :label="n.nome"
                                                    ></v-checkbox>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 2"
                                                  >
                                                    <v-checkbox
                                                      :disabled="true"
                                                      color="#f8ac4a"
                                                      @change="
                                                        changeCheck(cc, n, 2)
                                                      "
                                                      v-model="n.checked"
                                                      :label="n.nome"
                                                    ></v-checkbox>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 3"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-text-field
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                      ></v-text-field>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 8"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-textarea
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        rows="2"
                                                        auto-grow
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                      ></v-textarea>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 4"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-text-field
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        mask="################"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                      ></v-text-field>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 6"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-autocomplete
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        :items="getDistritos"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                        item-text="nome"
                                                        item-value="id_distrito"
                                                      ></v-autocomplete>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 7"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-autocomplete
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        :items="getSetores"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                        item-text="nome"
                                                        item-value="id_setor"
                                                      ></v-autocomplete>
                                                    </v-flex>
                                                  </v-flex>
                                                </v-flex>
                                              </v-flex>
                                            </v-flex>
                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="child.id_tipo == 2"
                                            >
                                              <v-checkbox
                                                :disabled="true"
                                                color="#f8ac4a"
                                                @change="
                                                  changeCheck(child, cc, 2)
                                                "
                                                v-model="cc.checked"
                                                :label="cc.nome"
                                              ></v-checkbox>
                                              <v-flex
                                                xs12
                                                sm12
                                                md12
                                                v-if="
                                                  cc.expansivel && cc.checked
                                                "
                                              >
                                                <v-flex
                                                  xs12
                                                  sm12
                                                  md12
                                                  v-for="(n, k1) in cc.children"
                                                  :key="k1"
                                                >
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 1"
                                                  >
                                                    <v-checkbox
                                                      :disabled="true"
                                                      color="#f8ac4a"
                                                      @change="
                                                        changeCheck(cc, n, 1)
                                                      "
                                                      v-model="n.checked"
                                                      :label="n.nome"
                                                    ></v-checkbox>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 2"
                                                  >
                                                    <v-checkbox
                                                      :disabled="true"
                                                      color="#f8ac4a"
                                                      @change="
                                                        changeCheck(cc, n, 2)
                                                      "
                                                      v-model="n.checked"
                                                      :label="n.nome"
                                                    ></v-checkbox>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 3"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-text-field
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                      ></v-text-field>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 8"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-textarea
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        rows="2"
                                                        auto-grow
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                      ></v-textarea>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 4"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-text-field
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        mask="################"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                      ></v-text-field>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 6"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-autocomplete
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        :items="getDistritos"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                        item-text="nome"
                                                        item-value="id_distrito"
                                                      ></v-autocomplete>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 7"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-autocomplete
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        :items="getSetores"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                        item-text="nome"
                                                        item-value="id_setor"
                                                      ></v-autocomplete>
                                                    </v-flex>
                                                  </v-flex>
                                                </v-flex>
                                              </v-flex>
                                            </v-flex>
                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="child.id_tipo == 3"
                                            >
                                              <v-flex xs12 sm12 md12>
                                                <label class="label-modal">{{
                                                  cc.nome
                                                }}</label>
                                                <v-text-field
                                                  :disabled="true"
                                                  color="#f8ac4a"
                                                  @input="forceUpdate"
                                                  v-model="cc.valor"
                                                ></v-text-field>
                                              </v-flex>
                                            </v-flex>
                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="child.id_tipo == 8"
                                            >
                                              <v-flex xs12 sm12 md12>
                                                <label class="label-modal">{{
                                                  cc.nome
                                                }}</label>
                                                <v-textarea
                                                  :disabled="true"
                                                  color="#f8ac4a"
                                                  rows="2"
                                                  auto-grow
                                                  @input="forceUpdate"
                                                  v-model="cc.valor"
                                                ></v-textarea>
                                              </v-flex>
                                            </v-flex>
                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="child.id_tipo == 4"
                                            >
                                              <v-flex xs12 sm12 md12>
                                                <label class="label-modal">{{
                                                  cc.nome
                                                }}</label>
                                                <v-text-field
                                                  :disabled="true"
                                                  color="#f8ac4a"
                                                  mask="################"
                                                  @input="forceUpdate"
                                                  v-model="cc.valor"
                                                ></v-text-field>
                                              </v-flex>
                                            </v-flex>
                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="child.id_tipo == 6"
                                            >
                                              <v-flex xs12 sm12 md12>
                                                <label class="label-modal">{{
                                                  cc.nome
                                                }}</label>
                                                <v-autocomplete
                                                  :disabled="true"
                                                  color="#f8ac4a"
                                                  :items="getDistritos"
                                                  @input="forceUpdate"
                                                  v-model="cc.valor"
                                                  item-text="nome"
                                                  item-value="id_distrito"
                                                ></v-autocomplete>
                                              </v-flex>
                                            </v-flex>
                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="child.id_tipo == 7"
                                            >
                                              <v-flex xs12 sm12 md12>
                                                <label class="label-modal">{{
                                                  cc.nome
                                                }}</label>
                                                <v-autocomplete
                                                  :disabled="true"
                                                  color="#f8ac4a"
                                                  :items="getSetores"
                                                  @input="forceUpdate"
                                                  v-model="cc.valor"
                                                  item-text="nome"
                                                  item-value="id_setor"
                                                ></v-autocomplete>
                                              </v-flex>
                                            </v-flex>
                                          </v-flex>
                                        </v-flex>
                                      </v-flex>
                                      <v-flex
                                        xs12
                                        sm12
                                        md12
                                        v-if="p.pergunta.id_tipo == 2"
                                      >
                                        <v-checkbox
                                          :disabled="true"
                                          color="#f8ac4a"
                                          @change="
                                            changeCheck(p.pergunta, child, 2)
                                          "
                                          v-model="child.checked"
                                          :label="child.nome"
                                        ></v-checkbox>
                                        <v-flex
                                          xs12
                                          sm12
                                          md12
                                          v-if="
                                            child.expansivel && child.checked
                                          "
                                        >
                                          <v-flex
                                            xs12
                                            sm12
                                            md12
                                            v-for="(cc, kk) in child.children"
                                            :key="kk"
                                          >
                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="child.id_tipo == 1"
                                            >
                                              <v-checkbox
                                                :disabled="true"
                                                color="#f8ac4a"
                                                @change="
                                                  changeCheck(child, cc, 1)
                                                "
                                                v-model="cc.checked"
                                                :label="cc.nome"
                                              ></v-checkbox>
                                              <v-flex
                                                xs12
                                                sm12
                                                md12
                                                v-if="
                                                  cc.expansivel && cc.checked
                                                "
                                              >
                                                <v-flex
                                                  xs12
                                                  sm12
                                                  md12
                                                  v-for="(n, k1) in cc.children"
                                                  :key="k1"
                                                >
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 1"
                                                  >
                                                    <v-checkbox
                                                      :disabled="true"
                                                      color="#f8ac4a"
                                                      @change="
                                                        changeCheck(cc, n, 1)
                                                      "
                                                      v-model="n.checked"
                                                      :label="n.nome"
                                                    ></v-checkbox>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 2"
                                                  >
                                                    <v-checkbox
                                                      :disabled="true"
                                                      color="#f8ac4a"
                                                      @change="
                                                        changeCheck(cc, n, 2)
                                                      "
                                                      v-model="n.checked"
                                                      :label="n.nome"
                                                    ></v-checkbox>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 3"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-text-field
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                      ></v-text-field>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 8"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-textarea
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        rows="2"
                                                        auto-grow
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                      ></v-textarea>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 4"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-text-field
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        mask="################"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                      ></v-text-field>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 6"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-autocomplete
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        :items="getDistritos"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                        item-text="nome"
                                                        item-value="id_distrito"
                                                      ></v-autocomplete>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 7"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-autocomplete
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        :items="getSetores"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                        item-text="nome"
                                                        item-value="id_setor"
                                                      ></v-autocomplete>
                                                    </v-flex>
                                                  </v-flex>
                                                </v-flex>
                                              </v-flex>
                                            </v-flex>
                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="child.id_tipo == 2"
                                            >
                                              <v-checkbox
                                                :disabled="true"
                                                color="#f8ac4a"
                                                @change="
                                                  changeCheck(child, cc, 2)
                                                "
                                                v-model="cc.checked"
                                                :label="cc.nome"
                                              ></v-checkbox>
                                              <v-flex
                                                xs12
                                                sm12
                                                md12
                                                v-if="
                                                  cc.expansivel && cc.checked
                                                "
                                              >
                                                <v-flex
                                                  xs12
                                                  sm12
                                                  md12
                                                  v-for="(n, k1) in cc.children"
                                                  :key="k1"
                                                >
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 1"
                                                  >
                                                    <v-checkbox
                                                      :disabled="true"
                                                      color="#f8ac4a"
                                                      @change="
                                                        changeCheck(cc, n, 1)
                                                      "
                                                      v-model="n.checked"
                                                      :label="n.nome"
                                                    ></v-checkbox>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 2"
                                                  >
                                                    <v-checkbox
                                                      :disabled="true"
                                                      color="#f8ac4a"
                                                      @change="
                                                        changeCheck(cc, n, 2)
                                                      "
                                                      v-model="n.checked"
                                                      :label="n.nome"
                                                    ></v-checkbox>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 3"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-text-field
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                      ></v-text-field>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 8"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-textarea
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        rows="2"
                                                        auto-grow
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                      ></v-textarea>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 4"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-text-field
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        mask="################"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                      ></v-text-field>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 6"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-autocomplete
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        :items="getDistritos"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                        item-text="nome"
                                                        item-value="id_distrito"
                                                      ></v-autocomplete>
                                                    </v-flex>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="cc.id_tipo == 7"
                                                  >
                                                    <v-flex xs12 sm12 md12>
                                                      <label
                                                        class="label-modal"
                                                        >{{ n.nome }}</label
                                                      >
                                                      <v-autocomplete
                                                        :disabled="true"
                                                        color="#f8ac4a"
                                                        :items="getSetores"
                                                        @input="forceUpdate"
                                                        v-model="n.valor"
                                                        item-text="nome"
                                                        item-value="id_setor"
                                                      ></v-autocomplete>
                                                    </v-flex>
                                                  </v-flex>
                                                </v-flex>
                                              </v-flex>
                                            </v-flex>
                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="child.id_tipo == 3"
                                            >
                                              <v-flex xs12 sm12 md12>
                                                <label class="label-modal">{{
                                                  cc.nome
                                                }}</label>
                                                <v-text-field
                                                  :disabled="true"
                                                  color="#f8ac4a"
                                                  @input="forceUpdate"
                                                  v-model="child.valor"
                                                ></v-text-field>
                                              </v-flex>
                                            </v-flex>
                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="child.id_tipo == 8"
                                            >
                                              <v-flex xs12 sm12 md12>
                                                <label class="label-modal">{{
                                                  cc.nome
                                                }}</label>
                                                <v-textarea
                                                  :disabled="true"
                                                  color="#f8ac4a"
                                                  rows="2"
                                                  auto-grow
                                                  @input="forceUpdate"
                                                  v-model="cc.valor"
                                                ></v-textarea>
                                              </v-flex>
                                            </v-flex>
                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="child.id_tipo == 4"
                                            >
                                              <v-flex xs12 sm12 md12>
                                                <label class="label-modal">{{
                                                  cc.nome
                                                }}</label>
                                                <v-text-field
                                                  :disabled="true"
                                                  color="#f8ac4a"
                                                  mask="################"
                                                  @input="forceUpdate"
                                                  v-model="child.valor"
                                                ></v-text-field>
                                              </v-flex>
                                            </v-flex>
                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="child.id_tipo == 6"
                                            >
                                              <v-flex xs12 sm12 md12>
                                                <label class="label-modal">{{
                                                  cc.nome
                                                }}</label>
                                                <v-autocomplete
                                                  :disabled="true"
                                                  color="#f8ac4a"
                                                  :items="getDistritos"
                                                  @input="forceUpdate"
                                                  v-model="child.valor"
                                                  item-text="nome"
                                                  item-value="id_distrito"
                                                ></v-autocomplete>
                                              </v-flex>
                                            </v-flex>
                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="child.id_tipo == 7"
                                            >
                                              <v-flex xs12 sm12 md12>
                                                <label class="label-modal">{{
                                                  cc.nome
                                                }}</label>
                                                <v-autocomplete
                                                  :disabled="true"
                                                  color="#f8ac4a"
                                                  :items="getSetores"
                                                  @input="forceUpdate"
                                                  v-model="child.valor"
                                                  item-text="nome"
                                                  item-value="id_setor"
                                                ></v-autocomplete>
                                              </v-flex>
                                            </v-flex>
                                          </v-flex>
                                        </v-flex>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm12
                              md12
                              v-if="p.pergunta.id_tipo == 5"
                            >
                              <v-flex
                                xs12
                                sm12
                                md12
                                v-for="(child, i) in p.pergunta.children"
                                :key="i"
                              >
                                <v-layout row wrap align-center>
                                  <v-flex xs12 sm12 md12>
                                    <v-layout row wrap align-center>
                                      <v-flex
                                        xs12
                                        sm12
                                        md12
                                        style="display: grid !important"
                                      >
                                        <label class="child-2 label-nivel">{{
                                          child.nome
                                        }}</label>
                                        <label class="label-modal child-2"
                                          >{{ getLegenda(child.id_tipo) }}
                                          <span
                                            v-if="child.required"
                                            style="
                                              color: red !important;
                                              margin-left: 10px !important;
                                            "
                                            >* Obrigatória</span
                                          ></label
                                        >
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex
                                    xs12
                                    sm12
                                    md12
                                    v-if="
                                      child.id_tipo == 1 || child.id_tipo == 2
                                    "
                                  >
                                    <v-flex
                                      xs12
                                      sm12
                                      md12
                                      v-for="(c, j) in child.children"
                                      :key="j"
                                    >
                                      <v-layout row wrap align-center>
                                        <v-flex class="child-3" xs8 sm8 md8>
                                          <v-flex
                                            xs12
                                            sm12
                                            md12
                                            v-if="child.id_tipo == 1"
                                          >
                                            <v-checkbox
                                              :disabled="true"
                                              color="#f8ac4a"
                                              @change="changeCheck(child, c, 1)"
                                              v-model="c.checked"
                                              :label="c.nome"
                                            ></v-checkbox>
                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="c.expansivel && c.checked"
                                            >
                                              <v-flex
                                                v-if="
                                                  (c.id_tipo == 1) |
                                                    (c.id_tipo == 2)
                                                "
                                              >
                                                <v-flex
                                                  xs12
                                                  sm12
                                                  md12
                                                  v-for="(n, k) in c.children"
                                                  :key="k"
                                                >
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="c.id_tipo == 1"
                                                  >
                                                    <v-checkbox
                                                      :disabled="true"
                                                      color="#f8ac4a"
                                                      @change="
                                                        changeCheck(c, n, 1)
                                                      "
                                                      v-model="n.checked"
                                                      :label="n.nome"
                                                    ></v-checkbox>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="c.id_tipo == 2"
                                                  >
                                                    <v-checkbox
                                                      :disabled="true"
                                                      color="#f8ac4a"
                                                      @change="
                                                        changeCheck(c, n, 2)
                                                      "
                                                      v-model="n.checked"
                                                      :label="n.nome"
                                                    ></v-checkbox>
                                                  </v-flex>
                                                </v-flex>
                                              </v-flex>
                                              <v-flex
                                                xs12
                                                sm12
                                                md12
                                                v-if="c.id_tipo == 3"
                                              >
                                                <v-flex xs12 sm12 md12>
                                                  <v-text-field
                                                    :disabled="true"
                                                    color="#f8ac4a"
                                                    @input="forceUpdate"
                                                    v-model="c.valor"
                                                  ></v-text-field>
                                                </v-flex>
                                              </v-flex>
                                              <v-flex
                                                xs12
                                                sm12
                                                md12
                                                v-if="c.id_tipo == 8"
                                              >
                                                <v-flex xs12 sm12 md12>
                                                  <v-textarea
                                                    :disabled="true"
                                                    color="#f8ac4a"
                                                    rows="2"
                                                    auto-grow
                                                    @input="forceUpdate"
                                                    v-model="c.valor"
                                                  ></v-textarea>
                                                </v-flex>
                                              </v-flex>
                                              <v-flex
                                                xs12
                                                sm12
                                                md12
                                                v-if="c.id_tipo == 4"
                                              >
                                                <v-flex xs12 sm12 md12>
                                                  <v-text-field
                                                    :disabled="true"
                                                    color="#f8ac4a"
                                                    mask="################"
                                                    @input="forceUpdate"
                                                    v-model="c.valor"
                                                  ></v-text-field>
                                                </v-flex>
                                              </v-flex>
                                              <v-flex
                                                xs12
                                                sm12
                                                md12
                                                v-if="c.id_tipo == 6"
                                              >
                                                <v-flex xs12 sm12 md12>
                                                  <v-autocomplete
                                                    :disabled="true"
                                                    color="#f8ac4a"
                                                    :items="getDistritos"
                                                    @input="forceUpdate"
                                                    v-model="c.valor"
                                                    item-text="nome"
                                                    item-value="id_distrito"
                                                  ></v-autocomplete>
                                                </v-flex>
                                              </v-flex>
                                              <v-flex
                                                xs12
                                                sm12
                                                md12
                                                v-if="c.id_tipo == 7"
                                              >
                                                <v-flex xs12 sm12 md12>
                                                  <v-autocomplete
                                                    :disabled="true"
                                                    color="#f8ac4a"
                                                    :items="getSetores"
                                                    @input="forceUpdate"
                                                    v-model="c.valor"
                                                    item-text="nome"
                                                    item-value="id_setor"
                                                  ></v-autocomplete>
                                                </v-flex>
                                              </v-flex>
                                            </v-flex>
                                          </v-flex>
                                          <v-flex
                                            xs12
                                            sm12
                                            md12
                                            v-if="child.id_tipo == 2"
                                          >
                                            <v-checkbox
                                              :disabled="true"
                                              color="#f8ac4a"
                                              @change="changeCheck(child, c, 2)"
                                              v-model="c.checked"
                                              :label="c.nome"
                                            ></v-checkbox>

                                            <v-flex
                                              xs12
                                              sm12
                                              md12
                                              v-if="c.expansivel && c.checked"
                                            >
                                              <v-flex
                                                v-if="
                                                  (c.id_tipo == 1) |
                                                    (c.id_tipo == 2)
                                                "
                                              >
                                                <v-flex
                                                  xs12
                                                  sm12
                                                  md12
                                                  v-for="(n, k) in c.children"
                                                  :key="k"
                                                >
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="c.id_tipo == 1"
                                                  >
                                                    <v-checkbox
                                                      :disabled="true"
                                                      color="#f8ac4a"
                                                      @change="
                                                        changeCheck(c, n, 1)
                                                      "
                                                      v-model="n.checked"
                                                      :label="n.nome"
                                                    ></v-checkbox>
                                                  </v-flex>
                                                  <v-flex
                                                    xs12
                                                    sm12
                                                    md12
                                                    v-if="c.id_tipo == 2"
                                                  >
                                                    <v-checkbox
                                                      :disabled="true"
                                                      color="#f8ac4a"
                                                      @change="
                                                        changeCheck(c, n, 2)
                                                      "
                                                      v-model="n.checked"
                                                      :label="n.nome"
                                                    ></v-checkbox>
                                                  </v-flex>
                                                </v-flex>
                                              </v-flex>
                                              <v-flex
                                                xs12
                                                sm12
                                                md12
                                                v-if="c.id_tipo == 3"
                                              >
                                                <v-flex xs12 sm12 md12>
                                                  <v-text-field
                                                    :disabled="true"
                                                    color="#f8ac4a"
                                                    @input="forceUpdate"
                                                    v-model="c.valor"
                                                  ></v-text-field>
                                                </v-flex>
                                              </v-flex>
                                              <v-flex
                                                xs12
                                                sm12
                                                md12
                                                v-if="c.id_tipo == 8"
                                              >
                                                <v-flex xs12 sm12 md12>
                                                  <v-textarea
                                                    :disabled="true"
                                                    color="#f8ac4a"
                                                    rows="2"
                                                    auto-grow
                                                    @input="forceUpdate"
                                                    v-model="c.valor"
                                                  ></v-textarea>
                                                </v-flex>
                                              </v-flex>
                                              <v-flex
                                                xs12
                                                sm12
                                                md12
                                                v-if="c.id_tipo == 4"
                                              >
                                                <v-flex xs12 sm12 md12>
                                                  <v-text-field
                                                    :disabled="true"
                                                    color="#f8ac4a"
                                                    mask="################"
                                                    @input="forceUpdate"
                                                    v-model="c.valor"
                                                  ></v-text-field>
                                                </v-flex>
                                              </v-flex>
                                              <v-flex
                                                xs12
                                                sm12
                                                md12
                                                v-if="c.id_tipo == 6"
                                              >
                                                <v-flex xs12 sm12 md12>
                                                  <v-autocomplete
                                                    :disabled="true"
                                                    color="#f8ac4a"
                                                    :items="getDistritos"
                                                    @input="forceUpdate"
                                                    v-model="c.valor"
                                                    item-text="nome"
                                                    item-value="id_distrito"
                                                  ></v-autocomplete>
                                                </v-flex>
                                              </v-flex>
                                              <v-flex
                                                xs12
                                                sm12
                                                md12
                                                v-if="c.id_tipo == 7"
                                              >
                                                <v-flex xs12 sm12 md12>
                                                  <v-autocomplete
                                                    :disabled="true"
                                                    color="#f8ac4a"
                                                    :items="getSetores"
                                                    @input="forceUpdate"
                                                    v-model="c.valor"
                                                    item-text="nome"
                                                    item-value="id_setor"
                                                  ></v-autocomplete>
                                                </v-flex>
                                              </v-flex>
                                            </v-flex>
                                          </v-flex>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-flex>
                                  <v-flex
                                    xs12
                                    sm12
                                    md12
                                    v-if="child.id_tipo == 3"
                                  >
                                    <v-flex class="child-3" xs12 sm12 md12>
                                      <v-text-field
                                        :disabled="true"
                                        color="#f8ac4a"
                                        @input="forceUpdate"
                                        v-model="child.valor"
                                      ></v-text-field>
                                    </v-flex>
                                  </v-flex>
                                  <v-flex
                                    xs12
                                    sm12
                                    md12
                                    v-if="child.id_tipo == 8"
                                  >
                                    <v-flex xs12 sm12 md12>
                                      <v-textarea
                                        :disabled="true"
                                        color="#f8ac4a"
                                        rows="2"
                                        auto-grow
                                        @input="forceUpdate"
                                        v-model="child.valor"
                                      ></v-textarea>
                                    </v-flex>
                                  </v-flex>
                                  <v-flex
                                    xs12
                                    sm12
                                    md12
                                    v-if="child.id_tipo == 4"
                                  >
                                    <v-flex class="child-3" xs12 sm12 md12>
                                      <v-text-field
                                        :disabled="true"
                                        color="#f8ac4a"
                                        mask="################"
                                        @input="forceUpdate"
                                        v-model="child.valor"
                                      ></v-text-field>
                                    </v-flex>
                                  </v-flex>
                                  <v-flex
                                    xs12
                                    sm12
                                    md12
                                    v-if="child.id_tipo == 6"
                                  >
                                    <v-flex class="child-3" xs12 sm12 md12>
                                      <v-autocomplete
                                        :disabled="true"
                                        color="#f8ac4a"
                                        :items="getDistritos"
                                        @input="forceUpdate"
                                        v-model="child.valor"
                                        item-text="nome"
                                        item-value="id_distrito"
                                      ></v-autocomplete>
                                    </v-flex>
                                  </v-flex>
                                  <v-flex
                                    xs12
                                    sm12
                                    md12
                                    v-if="child.id_tipo == 7"
                                  >
                                    <v-flex class="child-3" xs12 sm12 md12>
                                      <v-autocomplete
                                        :disabled="true"
                                        color="#f8ac4a"
                                        :items="getSetores"
                                        @input="forceUpdate"
                                        v-model="child.valor"
                                        item-text="nome"
                                        item-value="id_setor"
                                      ></v-autocomplete>
                                    </v-flex>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-flex>
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md12
                            v-else-if="p.pergunta.id_tipo == 3"
                          >
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                :disabled="true"
                                color="#f8ac4a"
                                @input="forceUpdate"
                                v-model="p.pergunta.valor"
                              ></v-text-field>
                            </v-flex>
                          </v-flex>
                          <v-flex xs12 sm12 md12 v-if="p.pergunta.id_tipo == 8">
                            <v-flex xs12 sm12 md12>
                              <v-textarea
                                :disabled="true"
                                color="#f8ac4a"
                                rows="2"
                                auto-grow
                                @input="forceUpdate"
                                v-model="p.pergunta.valor"
                              ></v-textarea>
                            </v-flex>
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md12
                            v-else-if="p.pergunta.id_tipo == 4"
                          >
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                :disabled="true"
                                color="#f8ac4a"
                                mask="################"
                                @input="forceUpdate"
                                v-model="p.pergunta.valor"
                              ></v-text-field>
                            </v-flex>
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md12
                            v-else-if="p.pergunta.id_tipo == 6"
                          >
                            <v-flex xs12 sm12 md12>
                              <v-autocomplete
                                :disabled="true"
                                color="#f8ac4a"
                                :items="getDistritos"
                                @input="forceUpdate"
                                v-model="p.pergunta.valor"
                                item-text="nome"
                                item-value="id_distrito"
                              ></v-autocomplete>
                            </v-flex>
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md12
                            v-else-if="p.pergunta.id_tipo == 7"
                          >
                            <v-flex xs12 sm12 md12>
                              <v-autocomplete
                                :disabled="true"
                                color="#f8ac4a"
                                :items="getSetores"
                                @input="forceUpdate"
                                v-model="p.pergunta.valor"
                                item-text="nome"
                                item-value="id_setor"
                              ></v-autocomplete>
                            </v-flex>
                          </v-flex>
                        </v-stepper-content>
                      </template>
                    </v-stepper>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#f8ac4a" flat @click.native="close">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="modal" max-width="700px">
        <v-card v-if="editedIndex > -1">
          <v-card-title>
            <span class="headline"
              >Proposta -
              {{ getInstituicaoById(editedItem.id_instituicao).nome }}</span
            >
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <label class="label-modal">Tipo de ação</label>
                  <v-autocomplete
                    :disabled="true"
                    color="#f8ac4a"
                    :items="getTiposAcao"
                    v-model="editedItem.id_tipo_acao"
                    item-text="nome"
                    item-value="id_tipo_acao"
                    :rules="defaultRules"
                  ></v-autocomplete>
                </v-flex>
                <v-flex
                  v-if="
                    editedItem.id_tipo_acao == 1 || editedItem.id_tipo_acao == 2
                  "
                  xs12
                  sm12
                  md12
                >
                  <label class="label-modal">Designação do projeto</label>
                  <v-text-field
                    :disabled="true"
                    color="#f8ac4a"
                    v-model="editedItem.design_proj"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <label class="label-modal">Designação da ação</label>
                  <v-text-field
                    :disabled="true"
                    color="#f8ac4a"
                    :rules="defaultRules"
                    v-model="editedItem.design_acao"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <label class="label-modal">Objetivo</label>
                  <v-autocomplete
                    :disabled="true"
                    color="#f8ac4a"
                    :items="getObjetivos"
                    v-model="editedItem.id_objetivo"
                    item-text="nome"
                    item-value="id_objetivo"
                    :rules="defaultRules"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <label class="label-modal">Medida</label>
                  <v-autocomplete
                    :disabled="true"
                    color="#f8ac4a"
                    :items="getMedidasByObjetivo(editedItem.id_objetivo)"
                    v-model="editedItem.id_medida"
                    item-text="nome"
                    item-value="id_medida"
                    :rules="defaultRules"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <label class="label-modal">Ação</label>
                  <v-autocomplete
                    :disabled="true"
                    color="#f8ac4a"
                    :items="getAcoesByMedida(editedItem.id_medida)"
                    v-model="editedItem.id_acao"
                    item-text="nome"
                    item-value="id_acao"
                    :rules="defaultRules"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <label class="label-modal">Quando ano?</label>
                  <v-autocomplete
                    :disabled="true"
                    @change="changeAno()"
                    color="#f8ac4a"
                    :items="getAnos"
                    v-model="editedItem.id_ano"
                    :rules="defaultRules"
                    item-text="nome"
                    item-value="id_ano"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <label class="label-modal">Quando mês?</label>
                  <v-autocomplete
                    :disabled="true"
                    color="#f8ac4a"
                    :items="getMeses"
                    v-model="editedItem.mes"
                    item-text="nome"
                    item-value="id_mes"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4 sm4 md4>
                  <label class="label-modal">Quando dia?</label>
                  <v-text-field
                    :disabled="true"
                    color="#f8ac4a"
                    v-model="editedItem.dia"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <label class="label-modal">Onde?</label>
                  <v-autocomplete
                    :disabled="true"
                    color="#f8ac4a"
                    :items="getDistritos"
                    v-model="editedItem.id_distrito"
                    item-text="nome"
                    item-value="id_distrito"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <label class="label-modal">A quem de destina?</label>
                  <v-text-field
                    :disabled="true"
                    color="#f8ac4a"
                    :rules="defaultRules"
                    v-model="editedItem.quem"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <label class="label-modal">Descrição</label>
                  <v-textarea
                    :disabled="true"
                    color="#f8ac4a"
                    :rules="defaultRules"
                    auto-grow
                    :rows="2"
                    :counter="500"
                    :maxlength="500"
                    v-model="editedItem.descricao"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              flat
              @click.native="reverterReporte()"
              v-if="editedItem.reporte == 1"
              >Reverter reporte</v-btn
            >

            <v-btn
              flat
              @click.native="reverterSubmissao()"
              v-if="editedItem.submetida == 1"
              >Reverter planificacao</v-btn
            >
            <v-btn color="#f8ac4a" flat @click.native="close">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div class="noTableHeader">
        <v-dialog persistent v-model="addNova" max-width="700px">
          <v-btn slot="activator" color="#f8ac4a" dark class="mb-2">
            <v-icon class="buttonIconText" color="white">playlist_add</v-icon>
            Nova {{ name }}
          </v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-form ref="form" v-on:submit.prevent>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <v-stepper style="box-shadow: none" v-model="stepper2">
                        <v-stepper-header style="box-shadow: none">
                          <v-stepper-step
                            color="#f8ac4a"
                            step="1"
                            :edit-icon="'done'"
                            :complete="NOVA.id_objetivo > 0"
                            @click="stepper2 = 1"
                            >Objetivo</v-stepper-step
                          >

                          <v-divider></v-divider>

                          <v-stepper-step
                            color="#f8ac4a"
                            step="2"
                            :edit-icon="'done'"
                            :complete="NOVA.id_medida > 0"
                            @click="stepper2 = 2"
                            >Medida</v-stepper-step
                          >

                          <v-divider></v-divider>

                          <v-stepper-step
                            color="#f8ac4a"
                            step="3"
                            :edit-icon="'done'"
                            :complete="NOVA.id_acao > 0"
                            @click="stepper2 = 3"
                            >Ação</v-stepper-step
                          >

                          <v-divider></v-divider>

                          <v-stepper-step
                            color="#f8ac4a"
                            step="4"
                            @click="stepper2 = 4"
                            >Dados</v-stepper-step
                          >
                        </v-stepper-header>

                        <v-stepper-items>
                          <v-stepper-content step="1">
                            <v-card style="box-shadow: none" class="mb-5">
                              <v-radio-group
                                @change="changeObjetivo"
                                v-model="NOVA.id_objetivo"
                              >
                                <v-radio
                                  class="mb-3"
                                  color="#f8ac4a"
                                  v-for="(item, o) in getObjetivos"
                                  :key="'o-' + o"
                                  :label="item.nome + ' - ' + item.descricao"
                                  :value="item.id_objetivo"
                                ></v-radio>
                              </v-radio-group>
                            </v-card>
                          </v-stepper-content>

                          <v-stepper-content step="2">
                            <v-card style="box-shadow: none" class="mb-5">
                              <v-radio-group
                                v-if="
                                  NOVA.id_objetivo > 0 &&
                                    getMedidasByObjetivo(NOVA.id_objetivo)
                                      .length > 0
                                "
                                @change="changeMedida"
                                v-model="NOVA.id_medida"
                              >
                                <v-radio
                                  class="mb-3"
                                  color="#f8ac4a"
                                  v-for="(item, m) in getMedidasByObjetivo(
                                    NOVA.id_objetivo
                                  )"
                                  :key="'m-' + m"
                                  :label="item.nome + ' - ' + item.descricao"
                                  :value="item.id_medida"
                                ></v-radio>
                              </v-radio-group>
                              <span v-else-if="NOVA.id_objetivo == 0"
                                >Precisa de escolher um objetivo.</span
                              >
                              <span
                                v-else-if="
                                  NOVA.id_objetivo > 0 &&
                                    getMedidasByObjetivo(NOVA.id_objetivo)
                                      .length == 0
                                "
                                >Não existem medidas associadas a este
                                objetivo.</span
                              >
                            </v-card>
                          </v-stepper-content>

                          <v-stepper-content step="3">
                            <v-card style="box-shadow: none" class="mb-5">
                              <v-radio-group
                                v-if="
                                  NOVA.id_medida > 0 &&
                                    getAcoesByMedida(NOVA.id_medida).length > 0
                                "
                                @change="changeAcao"
                                v-model="NOVA.id_acao"
                              >
                                <v-radio
                                  class="mb-3"
                                  color="#f8ac4a"
                                  v-for="(item, a) in getAcoesByMedida(
                                    NOVA.id_medida
                                  )"
                                  :key="'m-' + a"
                                  :label="item.nome + ' - ' + item.descricao"
                                  :value="item.id_acao"
                                ></v-radio>
                              </v-radio-group>
                              <span v-else-if="NOVA.id_medida == 0"
                                >Precisa de escolher uma medida.</span
                              >
                              <span
                                v-else-if="
                                  NOVA.id_medida > 0 &&
                                    getAcoesByMedida(NOVA.id_medida).length == 0
                                "
                                >Não existem ações associadas a esta
                                medida.</span
                              >
                            </v-card>
                          </v-stepper-content>

                          <v-stepper-content step="4">
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <label class="label-modal">Instituição</label>
                                <v-autocomplete
                                  color="#f8ac4a"
                                  :items="getAllInstituicoes"
                                  v-model="NOVA.id_instituicao"
                                  item-text="nome"
                                  item-value="id_instituicao"
                                  :rules="defaultRules"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs4 sm4 md4>
                                <label class="label-modal"
                                  >Nº ações em 2018?</label
                                >
                                <v-text-field
                                  color="#f8ac4a"
                                  v-model="NOVA.ano1"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs4 sm4 md4>
                                <label class="label-modal"
                                  >Nº ações em 2019?</label
                                >
                                <v-text-field
                                  color="#f8ac4a"
                                  v-model="NOVA.ano2"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs4 sm4 md4>
                                <label class="label-modal"
                                  >Nº ações em 2020?</label
                                >
                                <v-text-field
                                  color="#f8ac4a"
                                  v-model="NOVA.ano3"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs4 sm4 md4>
                                <label class="label-modal"
                                  >Nº ações em 2021?</label
                                >
                                <v-text-field
                                  color="#f8ac4a"
                                  v-model="NOVA.ano4"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs4 sm4 md4>
                                <label class="label-modal"
                                  >Nº ações em 2022?</label
                                >
                                <v-text-field
                                  color="#f8ac4a"
                                  v-model="NOVA.ano5"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-stepper-content>
                        </v-stepper-items>
                      </v-stepper>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#f8ac4a" flat @click.native="close"
                  >Cancelar</v-btn
                >
                <v-btn color="#f8ac4a" flat @click.native="save">Guardar</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-text-field
          color="#f8ac4a"
          class="searchTable"
          v-model="search"
          append-icon="search"
          label="Pesquisa"
          single-line
          hide-details
        ></v-text-field>
      </div>

      <v-dialog persistent v-model="deleteM" max-width="390">
        <v-card>
          <v-card-title class="headline" style="margin-left: 0px !important"
            >Apagar {{ name }}</v-card-title
          >
          <v-card-text>De certeza que quer apagar esta {{ name }}?</v-card-text>
          <v-card-actions style="margin-top: 0px !important">
            <v-spacer></v-spacer>
            <v-btn color="#f8ac4a" flat="flat" @click.native="close"
              >Cancelar</v-btn
            >
            <v-btn color="#f8ac4a" flat="flat" @click.native="save"
              >Apagar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-data-table
        :headers="headers"
        :items="DATA"
        :search="search"
        :loading="loading"
        item-key="id"
        :disable-initial-sort="true"
        :rows-per-page-items="[10, 25, 50, { text: 'Todos', value: -1 }]"
        rows-per-page-text="Itens por página:"
      >
        <template slot="items" slot-scope="props">
          <td @click="editItem(props.item, true)" class="textLeft">
            {{ getInstituicaoById(props.item.id_instituicao).nome }}
          </td>
          <td @click="editItem(props.item, true)" class="textCenter">
            {{ props.item.design_acao || "-" }}
          </td>
          <td @click="editItem(props.item, true)" class="textCenter">
            {{ getAnoById(props.item.id_ano).nome }}
          </td>
          <td @click="editItem(props.item, true)" class="textCenter">
            <span v-if="props.item.submetida == 0" style="color: red"
              >PLANIFICAÇÂO NÂO SUBMETIDA</span
            >
            <span v-if="props.item.submetida == 1" style="color: green"
              >PLANIFICAÇÂO SUBMETIDA</span
            >
          </td>
          <td @click="reporte(props.item)" class="textCenter">
            <span v-if="props.item.reporte == 0" style="color: red"
              >REPORTE NÂO SUBMETIDO</span
            >
            <span v-if="props.item.reporte == 1" style="color: green"
              >REPORTE SUBMETIDO</span
            >
          </td>
          <td class="px-0 textTable textCenter">
            <v-btn icon class="mx-0" @click="reporte(props.item, true)">
              <v-icon color="light-green darken-1">picture_as_pdf</v-icon>
            </v-btn>
            <v-btn
              :disabled="props.item.submetida == 1"
              icon
              class="mx-0"
              @click="editItem(props.item, false)"
            >
              <v-icon color="red lighten-1">delete</v-icon>
            </v-btn>
          </td>
        </template>

        <template class="alertTable" slot="no-data">
          <!-- <v-alert :value="true" icon="warning">
                    De momento não há nada a apresentar! :(
                </v-alert> -->
          <v-progress-circular
            v-if="loading"
            style="margin-left: 50% !important"
            indeterminate
            color="#f8ac4a"
          ></v-progress-circular>
        </template>
      </v-data-table>
    </div>
  </v-flex>
</template>

<script>
import { instance as axios } from "../../store/axios";
import { mapState, mapGetters, mapActions } from "vuex";
const cName = {
  upper: "Proposta",
  lower: "a proposta!",
};

export default {
  data: () => ({
    table: "propostas",
    name: "proposta",
    search: "",
    stepper: 1,
    stepper2: 1,
    addNova: false,
    exportingProgress: 0,
    modal: false,
    waiting: false,
    deleteM: false,
    loading: true,
    reporteM: false,
    generating: false,
    FILTRO: {
      id_objetivo: 0,
      id_medida: 0,
      id_acao: 0,
      id_ano: 0,
      id_instituicao: 0,
    },
    searchP: "",
    NOVA: {
      id_objetivo: 0,
      id_medida: 0,
      id_acao: 0,
      ano1: "",
      ano2: "",
      ano3: "",
      ano4: "",
      ano5: "",
      id_instituicao: 0,
    },
    DEFAULT_NOVA: {
      id_objetivo: 0,
      id_medida: 0,
      id_acao: 0,
      ano1: "",
      ano2: "",
      ano3: "",
      ano4: "",
      ano5: "",
      id_instituicao: 0,
    },
    headers: [
      {
        text: "Instituição",
        align: "left",
        value: "id_instituicao",
      },
      {
        text: "Nome ação",
        align: "center",
        value: "design_acao",
      },
      {
        text: "Ano",
        align: "center",
        value: "id_ano",
      },
      {
        text: "Submetida?",
        align: "center",
        value: "id_proposta",
      },
      {
        text: "Reporte?",
        align: "center",
        value: "id_proposta",
      },
      {
        text: "Ações",
        value: "id",
        sortable: false,
        align: "center",
      },
    ],
    DATA: [],
    editedIndex: -1,
    editedItem: {
      id_proposta: 0,
      nome: "",
    },
    defaultItem: {
      id_proposta: 0,
      nome: "",
    },
    messages: {
      add: {
        success: cName.upper + " criada com sucesso!",
        error: "Ocorreu um erro ao criar " + cName.lower,
      },
      update: {
        success: cName.upper + " alterada com sucesso!",
        error: "Ocorreu um erro ao alterar " + cName.lower,
      },
      delete: {
        success: cName.upper + " eliminada com sucesso!",
        error: "Ocorreu um erro ao apagar " + cName.lower,
      },
      default: {
        sucesso: "Sucesso",
        error: "Ocorreu um erro!",
      },
    },
    defaultRules: null,
  }),

  computed: {
    ...mapGetters({
      getAll: "propostas/getAll",
      getAllInstituicoes: "instituicoes/getAllInstituicoes",
      getObjetivos: "objetivos/getAll",
      getMedidasByObjetivo: "medidas/getMedidasByObjetivo",
      getAcoesByMedida: "acoes/getAcoesByMedida",
      getDistritos: "distritos/getAll",
      getAnos: "anos/getAll",
      getAnoById: "anos/getById",
      getMedidaById: "medidas/getById",
      getObjetivoById: "objetivos/getById",
      getTiposAcao: "tipos_acao/getAll",
      getAcaoById: "acoes/getById",
      getMeses: "meses/getAll",
      isPlanificacaoAberta: "fases/isPlanificacaoAberta",
      isReporteAberta: "fases/isReporteAberta",
      getFormularioById: "formularios/getById",
      getPerguntaById: "perguntas/getById",
      getSetores: "setores/getAll",
      getDimensaoById: "dimensoes/getById",
      getInstituicaoById: "instituicoes/getById",
    }),
    formTitle() {
      return this.editedIndex === -1
        ? "Nova " + this.name
        : "Editar " + this.name;
    },
  },

  watch: {
    addNova(val) {
      val || this.close();
    },
    modal(val) {
      val || this.close();
    },
    deleteM(val) {
      val || this.close();
    },
    getAll(val) {
      this.initialize();
    },
  },

  created() {
    this.defaultRules = [(v) => !!v || this.$requiredField + ""];
    this.initialize();
  },
  mounted() {},
  methods: {
    async filtrar() {
      var array = [].concat(this.getAll);

      if (this.FILTRO.id_objetivo > 0) array = await this.filterObjetivo(array);
      if (this.FILTRO.id_medida > 0) array = await this.filterMedida(array);
      if (this.FILTRO.id_acao > 0) array = await this.filterAcao(array);
      if (this.FILTRO.id_instituicao > 0)
        array = await this.filterInstituicao(array);
      if (this.FILTRO.id_ano > 0) array = await this.filterAno(array);

      this.DATA = array;
    },

    limpar() {
      this.FILTRO = {
        id_objetivo: 0,
        id_medida: 0,
        id_acao: 0,
        id_ano: 0,
        id_instituicao: 0,
      };
      this.initialize();
    },

    filterObjetivo(array) {
      return array.filter((el) => {
        return el.id_objetivo == this.FILTRO.id_objetivo;
      });
    },
    filterMedida(array) {
      return array.filter((el) => {
        return el.id_medida == this.FILTRO.id_medida;
      });
    },
    filterAcao(array) {
      return array.filter((el) => {
        return el.id_acao == this.FILTRO.id_acao;
      });
    },
    filterInstituicao(array) {
      return array.filter((el) => {
        return el.id_instituicao == this.FILTRO.id_instituicao;
      });
    },
    filterAno(array) {
      return array.filter((el) => {
        return el.id_ano == this.FILTRO.id_ano;
      });
    },

    changeObjetivo() {
      this.NOVA.id_medida = 0;
      this.NOVA.id_acao = 0;
      this.stepper2 = 2;
    },

    changeMedida() {
      this.NOVA.id_acao = 0;
      this.stepper2 = 3;
    },

    changeAcao() {
      this.stepper2 = 4;
    },

    toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition,
        });
      } else {
        return iziToast.show({
          title: "AVISO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition,
        });
      }
    },

    initialize() {
      this.loading = true;
      this.DATA = this.getAll;
      this.loading = false;
    },

    editItem(item, dialog) {
      this.editedIndex = this.DATA.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.stepper2 = 4;

      if (dialog) this.modal = true;
      else this.deleteM = true;
    },

    reverterReporte() {
      if (!this.editedItem.id_proposta) return;

      this.$store
        .dispatch(this.table + "/reverter_reporte", {
          id: this.editedItem.id_proposta,
        })
        .then((res) => {
          this.toast("success", "Estado do reporte alterado");
          this.modal = false;
          this.initialize();
        });
    },

    reverterSubmissao() {
      if (!this.editedItem.id_proposta) return;

      this.$store
        .dispatch(this.table + "/reverter_submissao", {
          id: this.editedItem.id_proposta,
        })
        .then((res) => {
          this.toast("success", "Estado do reporte alterado");
          this.modal = false;
          this.initialize();
        });
    },

    delete() {
      if (!this.editedItem.id_proposta) return;

      this.$store
        .dispatch(this.table + "/delete", {
          id: this.editedItem.id_proposta,
        })
        .then((res) => {
          if (res) {
            this.toast("success", this.messages.delete.success);
            this.initialize();
          } else this.toast("error", this.messages.delete.error);

          this.deleteM = false;
        });
    },

    close() {
      this.modal = this.deleteM = this.addNova = this.reporteM = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.NOVA = Object.assign({}, this.DEFAULT_NOVA);
        this.editedIndex = -1;

        setTimeout(() => {
          this.stepper = 1;
          this.stepper2 = 1;
          this.$refs.formReporte.reset();
        }, 150);

        this.$refs.form.reset();
      }, 110);
    },

    save() {
      if (this.deleteM) {
        this.delete();
        return;
      }

      if (!this.$refs.form.validate()) return;

      if (this.editedIndex == -1) {
        this.$store
          .dispatch(this.table + "/add", {
            data: this.NOVA,
            auto_proposta: 0,
          })
          .then((res) => {
            if (res) {
              this.toast("success", this.messages.add.success);
              this.initialize();
            } else this.toast("error", this.messages.add.error);

            this.addNova = false;
          });
      }
    },

    sleep() {
      return new Promise((resolve) => {
        this.waiting = true;
        setTimeout(() => {
          resolve();
        }, 120);
      });
    },

    async reporte(item, pdf = false) {
      if (!item) return;
      this.exportingProgress = 0;

      this.sleep().then(async () => {
        let array = [];

        this.editedIndex = this.DATA.indexOf(item);
        this.editedItem = {};

        await axios.get("/proposta/" + item.id_proposta).then((res) => {
          if (res.data.results > 0) {
            this.editedItem = { ...res.data.data[0] };
          }
        });

        await axios
          .get("/formulario/" + this.getAcaoById(item.id_acao).id_formulario)
          .then((res) => {
            if (res.data.results > 0) {
              array = res.data.data[0].perguntas || [];
            }
          });

        const step = 100 / array.length;

        for (let p of array) {
          await axios.get("/pergunta/" + p.id_pergunta).then((res) => {
            p.pergunta = { ...res.data.data[0] };
          });
          this.exportingProgress += step;

          p.pergunta.ordem = await this.getDimensaoById(p.pergunta.id_dimensao)
            .ordem;

          if (
            p.pergunta.hasOwnProperty("children") &&
            p.pergunta.children.length > 0
          )
            p.pergunta.children = [].concat(
              p.pergunta.children.map((el) => {
                return Object.assign({}, el);
              })
            );

          if (
            p.pergunta.hasOwnProperty("children") &&
            p.pergunta.children.length > 0 &&
            p.pergunta.id_tipo == 5
          ) {
            for (let c of p.pergunta.children) {
              if (c.id_tipo == 1) {
                let el = Object.assign(
                  {},
                  this.editedItem.children.find((el) => {
                    return el.id_pergunta == c.id_pergunta;
                  })
                );
                if (typeof el != "undefined" && el.valor) {
                  let valor = el.valor;
                  let cc = c.children.find((el) => {
                    return el.id_pergunta == Number(valor);
                  });
                  await this.changeCheck(c, cc, 1, true);
                  c.valor = valor;

                  if (cc.expansivel && (cc.id_tipo == 1 || cc.id_tipo == 2)) {
                    let e = Object.assign(
                      {},
                      this.editedItem.children.find((el) => {
                        return el.id_pergunta == cc.id_pergunta;
                      })
                    );
                    if (typeof e != "undefined" && e.valor) {
                      let valor = e.valor.split(";").map((e) => {
                        return Number(e);
                      });
                      cc.valor = valor;

                      if (cc.id_tipo == 1) {
                        let e = Object.assign(
                          {},
                          this.editedItem.children.find((el) => {
                            return el.id_pergunta == cc.id_pergunta;
                          })
                        );
                        if (typeof e != "undefined" && e.valor) {
                          let valor = e.valor;
                          let ccc = cc.children.find((el) => {
                            return el.id_pergunta == Number(valor);
                          });
                          this.changeCheck(cc, ccc, 1, true);
                          cc.valor = valor;

                          if (
                            ccc.expansivel &&
                            (ccc.id_tipo == 1 || ccc.id_tipo == 2)
                          ) {
                            let e = Object.assign(
                              {},
                              this.editedItem.children.find((el) => {
                                return el.id_pergunta == ccc.id_pergunta;
                              })
                            );
                            if (typeof e != "undefined" && e.valor) {
                              let valor = e.valor.split(";").map((e) => {
                                return Number(e);
                              });
                              ccc.valor = valor;

                              if (ccc.id_tipo == 1) {
                                let e = Object.assign(
                                  {},
                                  this.editedItem.children.find((el) => {
                                    return el.id_pergunta == ccc.id_pergunta;
                                  })
                                );
                                if (typeof e != "undefined" && e.valor) {
                                  let valor = e.valor;
                                  this.changeCheck(
                                    cc,
                                    ccc.children.find((el) => {
                                      return el.id_pergunta == Number(valor);
                                    }),
                                    1,
                                    true
                                  );
                                  ccc.valor = valor;
                                }
                              } else if (ccc.id_tipo == 2) {
                                for (let vv of valor) {
                                  let ccc = ccc.children.find((el) => {
                                    return el.id_pergunta == Number(vv);
                                  });
                                  await this.changeCheck(cc, ccc, 2, true);
                                }
                              }
                            }
                          } else {
                            if (ccc.children && ccc.children.length > 0) {
                              ccc.children = [].concat(
                                ccc.children.map((el) => {
                                  return Object.assign({}, el);
                                })
                              );
                              for (let xy of ccc.children) {
                                let e = Object.assign(
                                  {},
                                  this.editedItem.children.find((el) => {
                                    return el.id_pergunta == xy.id_pergunta;
                                  })
                                );

                                if (typeof e != "undefined") xy.valor = e.valor;
                              }
                            } else {
                              let el = Object.assign(
                                {},
                                this.editedItem.children.find((el) => {
                                  return el.id_pergunta == ccc.id_pergunta;
                                })
                              );

                              if (typeof el != "undefined")
                                ccc.valor = el.valor;
                            }
                          }
                        }
                      } else if (cc.id_tipo == 2) {
                        for (let vv of valor) {
                          let ccc = cc.children.find((el) => {
                            return el.id_pergunta == Number(vv);
                          });
                          await this.changeCheck(cc, ccc, 2, true);

                          if (
                            ccc.expansivel &&
                            (ccc.id_tipo == 1 || ccc.id_tipo == 2)
                          ) {
                            let e = Object.assign(
                              {},
                              this.editedItem.children.find((el) => {
                                return el.id_pergunta == ccc.id_pergunta;
                              })
                            );
                            if (typeof e != "undefined" && e.valor) {
                              let valor = e.valor.split(";").map((e) => {
                                return Number(e);
                              });
                              ccc.valor = valor;

                              if (ccc.id_tipo == 1) {
                                let e = Object.assign(
                                  {},
                                  this.editedItem.children.find((el) => {
                                    return el.id_pergunta == ccc.id_pergunta;
                                  })
                                );
                                if (typeof e != "undefined" && e.valor) {
                                  let valor = e.valor;
                                  this.changeCheck(
                                    cc,
                                    ccc.children.find((el) => {
                                      return el.id_pergunta == Number(valor);
                                    }),
                                    1,
                                    true
                                  );
                                  ccc.valor = valor;
                                }
                              } else if (ccc.id_tipo == 2) {
                                for (let vv of valor) {
                                  let ccc = ccc.children.find((el) => {
                                    return el.id_pergunta == Number(vv);
                                  });
                                  await this.changeCheck(cc, ccc, 2, true);
                                }
                              }
                            }
                          }
                        }
                      } else {
                        let el = Object.assign(
                          {},
                          this.editedItem.children.find((el) => {
                            return el.id_pergunta == cc.id_pergunta;
                          })
                        );

                        if (typeof el != "undefined") cc.valor = el.valor;
                      }
                    }
                  } else {
                    if (cc.children && cc.children.length > 0) {
                      cc.children = [].concat(
                        cc.children.map((el) => {
                          return Object.assign({}, el);
                        })
                      );
                      for (let xy of cc.children) {
                        let e = Object.assign(
                          {},
                          this.editedItem.children.find((el) => {
                            return el.id_pergunta == xy.id_pergunta;
                          })
                        );

                        if (typeof e != "undefined") xy.valor = e.valor;
                      }
                    } else {
                      let el = Object.assign(
                        {},
                        this.editedItem.children.find((el) => {
                          return el.id_pergunta == cc.id_pergunta;
                        })
                      );

                      if (typeof el != "undefined") cc.valor = el.valor;
                    }
                  }
                }
              } else if (c.id_tipo == 2) {
                let el = Object.assign(
                  {},
                  this.editedItem.children.find((el) => {
                    return el.id_pergunta == c.id_pergunta;
                  })
                );
                if (typeof el != "undefined" && el.valor) {
                  let valor = el.valor.split(";").map((el) => {
                    return Number(el);
                  });
                  c.valor = valor;

                  for (let v of valor) {
                    let cc = c.children.find((el) => {
                      return el.id_pergunta == Number(v);
                    });

                    await this.changeCheck(c, cc, 2, true);

                    if (cc.expansivel && (cc.id_tipo == 1 || cc.id_tipo == 2)) {
                      let e = Object.assign(
                        {},
                        this.editedItem.children.find((el) => {
                          return el.id_pergunta == cc.id_pergunta;
                        })
                      );
                      if (typeof e != "undefined" && e.valor) {
                        let valor = e.valor.split(";").map((e) => {
                          return Number(e);
                        });
                        cc.valor = valor;

                        if (cc.id_tipo == 1) {
                          let e = Object.assign(
                            {},
                            this.editedItem.children.find((el) => {
                              return el.id_pergunta == cc.id_pergunta;
                            })
                          );
                          if (typeof e != "undefined" && e.valor) {
                            let valor = e.valor;
                            let ccc = cc.children.find((el) => {
                              return el.id_pergunta == Number(valor);
                            });
                            this.changeCheck(cc, ccc, 1, true);
                            cc.valor = valor;

                            if (
                              ccc.expansivel &&
                              (ccc.id_tipo == 1 || ccc.id_tipo == 2)
                            ) {
                              let e = Object.assign(
                                {},
                                this.editedItem.children.find((el) => {
                                  return el.id_pergunta == ccc.id_pergunta;
                                })
                              );
                              if (typeof e != "undefined" && e.valor) {
                                let valor = e.valor.split(";").map((e) => {
                                  return Number(e);
                                });
                                ccc.valor = valor;

                                if (ccc.id_tipo == 1) {
                                  let e = Object.assign(
                                    {},
                                    this.editedItem.children.find((el) => {
                                      return el.id_pergunta == ccc.id_pergunta;
                                    })
                                  );
                                  if (typeof e != "undefined" && e.valor) {
                                    let valor = e.valor;
                                    this.changeCheck(
                                      cc,
                                      ccc.children.find((el) => {
                                        return el.id_pergunta == Number(valor);
                                      }),
                                      1,
                                      true
                                    );
                                    ccc.valor = valor;
                                  }
                                } else if (ccc.id_tipo == 2) {
                                  for (let vv of valor) {
                                    let ccc = ccc.children.find((el) => {
                                      return el.id_pergunta == Number(vv);
                                    });
                                    await this.changeCheck(cc, ccc, 2, true);
                                  }
                                }
                              }
                            } else {
                              if (ccc.children && ccc.children.length > 0) {
                                ccc.children = [].concat(
                                  ccc.children.map((el) => {
                                    return Object.assign({}, el);
                                  })
                                );
                                for (let xy of ccc.children) {
                                  let e = Object.assign(
                                    {},
                                    this.editedItem.children.find((el) => {
                                      return el.id_pergunta == xy.id_pergunta;
                                    })
                                  );

                                  if (typeof e != "undefined")
                                    xy.valor = e.valor;
                                }
                              } else {
                                let el = Object.assign(
                                  {},
                                  this.editedItem.children.find((el) => {
                                    return el.id_pergunta == ccc.id_pergunta;
                                  })
                                );

                                if (typeof el != "undefined")
                                  ccc.valor = el.valor;
                              }
                            }
                          }
                        } else if (cc.id_tipo == 2) {
                          for (let vv of valor) {
                            let ccc = cc.children.find((el) => {
                              return el.id_pergunta == Number(vv);
                            });
                            await this.changeCheck(cc, ccc, 2, true);

                            if (
                              ccc.expansivel &&
                              (ccc.id_tipo == 1 || ccc.id_tipo == 2)
                            ) {
                              let e = Object.assign(
                                {},
                                this.editedItem.children.find((el) => {
                                  return el.id_pergunta == ccc.id_pergunta;
                                })
                              );
                              if (typeof e != "undefined" && e.valor) {
                                let valor = e.valor.split(";").map((e) => {
                                  return Number(e);
                                });
                                ccc.valor = valor;

                                if (ccc.id_tipo == 1) {
                                  let e = Object.assign(
                                    {},
                                    this.editedItem.children.find((el) => {
                                      return el.id_pergunta == ccc.id_pergunta;
                                    })
                                  );
                                  if (typeof e != "undefined" && e.valor) {
                                    let valor = e.valor;
                                    this.changeCheck(
                                      cc,
                                      ccc.children.find((el) => {
                                        return el.id_pergunta == Number(valor);
                                      }),
                                      1,
                                      true
                                    );
                                    ccc.valor = valor;
                                  }
                                } else if (ccc.id_tipo == 2) {
                                  for (let vv of valor) {
                                    let ccc = ccc.children.find((el) => {
                                      return el.id_pergunta == Number(vv);
                                    });
                                    await this.changeCheck(cc, ccc, 2, true);
                                  }
                                }
                              }
                            } else {
                              if (ccc.children && ccc.children.length > 0) {
                                ccc.children = [].concat(
                                  ccc.children.map((el) => {
                                    return Object.assign({}, el);
                                  })
                                );
                                for (let xy of ccc.children) {
                                  let e = Object.assign(
                                    {},
                                    this.editedItem.children.find((el) => {
                                      return el.id_pergunta == xy.id_pergunta;
                                    })
                                  );

                                  if (typeof e != "undefined")
                                    xy.valor = e.valor;
                                }
                              } else {
                                let el = Object.assign(
                                  {},
                                  this.editedItem.children.find((el) => {
                                    return el.id_pergunta == ccc.id_pergunta;
                                  })
                                );

                                if (typeof el != "undefined")
                                  ccc.valor = el.valor;
                              }
                            }
                          }
                        } else {
                          let el = Object.assign(
                            {},
                            this.editedItem.children.find((el) => {
                              return el.id_pergunta == cc.id_pergunta;
                            })
                          );

                          if (typeof el != "undefined") cc.valor = el.valor;
                        }
                      }
                    } else {
                      if (cc.children && cc.children.length > 0) {
                        cc.children = [].concat(
                          cc.children.map((el) => {
                            return Object.assign({}, el);
                          })
                        );
                        for (let xy of cc.children) {
                          let e = Object.assign(
                            {},
                            this.editedItem.children.find((el) => {
                              return el.id_pergunta == xy.id_pergunta;
                            })
                          );

                          if (typeof e != "undefined") xy.valor = e.valor;
                        }
                      } else {
                        let el = Object.assign(
                          {},
                          this.editedItem.children.find((el) => {
                            return el.id_pergunta == cc.id_pergunta;
                          })
                        );

                        if (typeof el != "undefined") cc.valor = el.valor;
                      }
                    }
                  }
                }
              } else {
                let el = Object.assign(
                  {},
                  this.editedItem.children.find((el) => {
                    return el.id_pergunta == c.id_pergunta;
                  })
                );
                if (typeof el != "undefined" && el.valor) {
                  let valor = el.valor;

                  if (Number.isInteger(Number(valor))) c.valor = Number(valor);
                  else c.valor = valor;
                }
              }
            }
          } else {
            if (p.pergunta.id_tipo == 1) {
              let el = Object.assign(
                {},
                this.editedItem.children.find((el) => {
                  return el.id_pergunta == p.pergunta.id_pergunta;
                })
              );

              if (typeof el != "undefined" && el.valor) {
                let valor = el.valor;
                let cc = p.pergunta.children.find((el) => {
                  return el.id_pergunta == Number(valor);
                });

                this.changeCheck(p.pergunta, cc, 1, true);
                p.pergunta.valor = valor;

                if (cc.expansivel && (cc.id_tipo == 1 || cc.id_tipo == 2)) {
                  let e = Object.assign(
                    {},
                    this.editedItem.children.find((el) => {
                      return el.id_pergunta == cc.id_pergunta;
                    })
                  );

                  if (typeof e != "undefined" && e.valor) {
                    let valor = e.valor.split(";").map((e) => {
                      return Number(e);
                    });
                    cc.valor = valor;

                    if (cc.id_tipo == 1) {
                      let e = Object.assign(
                        {},
                        this.editedItem.children.find((el) => {
                          return el.id_pergunta == cc.id_pergunta;
                        })
                      );
                      if (typeof e != "undefined" && e.valor) {
                        let valor = e.valor;
                        let ccc = cc.children.find((el) => {
                          return el.id_pergunta == Number(valor);
                        });
                        this.changeCheck(cc, ccc, 1, true);
                        cc.valor = valor;

                        if (
                          ccc.expansivel &&
                          (ccc.id_tipo == 1 || ccc.id_tipo == 2)
                        ) {
                          let e = Object.assign(
                            {},
                            this.editedItem.children.find((el) => {
                              return el.id_pergunta == ccc.id_pergunta;
                            })
                          );
                          if (typeof e != "undefined" && e.valor) {
                            let valor = e.valor.split(";").map((e) => {
                              return Number(e);
                            });
                            ccc.valor = valor;

                            if (ccc.id_tipo == 1) {
                              let e = Object.assign(
                                {},
                                this.editedItem.children.find((el) => {
                                  return el.id_pergunta == ccc.id_pergunta;
                                })
                              );
                              if (typeof e != "undefined" && e.valor) {
                                let valor = e.valor;
                                this.changeCheck(
                                  cc,
                                  ccc.children.find((el) => {
                                    return el.id_pergunta == Number(valor);
                                  }),
                                  1,
                                  true
                                );
                                ccc.valor = valor;
                              }
                            } else if (ccc.id_tipo == 2) {
                              for (let vv of valor) {
                                let ccc = ccc.children.find((el) => {
                                  return el.id_pergunta == Number(vv);
                                });
                                await this.changeCheck(cc, ccc, 2, true);
                              }
                            }
                          }
                        } else {
                          if (ccc.children && ccc.children.length > 0) {
                            ccc.children = [].concat(
                              ccc.children.map((el) => {
                                return Object.assign({}, el);
                              })
                            );
                            for (let xy of ccc.children) {
                              let e = Object.assign(
                                {},
                                this.editedItem.children.find((el) => {
                                  return el.id_pergunta == xy.id_pergunta;
                                })
                              );

                              if (typeof e != "undefined") xy.valor = e.valor;
                            }
                          } else {
                            let el = Object.assign(
                              {},
                              this.editedItem.children.find((el) => {
                                return el.id_pergunta == ccc.id_pergunta;
                              })
                            );

                            if (typeof el != "undefined") ccc.valor = el.valor;
                          }
                        }
                      }
                    } else if (cc.id_tipo == 2) {
                      for (let vv of valor) {
                        let ccc = cc.children.find((el) => {
                          return el.id_pergunta == Number(vv);
                        });
                        await this.changeCheck(cc, ccc, 2, true);

                        if (
                          ccc.expansivel &&
                          (ccc.id_tipo == 1 || ccc.id_tipo == 2)
                        ) {
                          let e = Object.assign(
                            {},
                            this.editedItem.children.find((el) => {
                              return el.id_pergunta == ccc.id_pergunta;
                            })
                          );
                          if (typeof e != "undefined" && e.valor) {
                            let valor = e.valor.split(";").map((e) => {
                              return Number(e);
                            });
                            ccc.valor = valor;

                            if (ccc.id_tipo == 1) {
                              let e = Object.assign(
                                {},
                                this.editedItem.children.find((el) => {
                                  return el.id_pergunta == ccc.id_pergunta;
                                })
                              );
                              if (typeof e != "undefined" && e.valor) {
                                let valor = e.valor;
                                this.changeCheck(
                                  cc,
                                  ccc.children.find((el) => {
                                    return el.id_pergunta == Number(valor);
                                  }),
                                  1,
                                  true
                                );
                                ccc.valor = valor;
                              }
                            } else if (ccc.id_tipo == 2) {
                              for (let vv of valor) {
                                let ccc = ccc.children.find((el) => {
                                  return el.id_pergunta == Number(vv);
                                });
                                await this.changeCheck(cc, ccc, 2, true);
                              }
                            }
                          }
                        } else {
                          if (ccc.children && ccc.children.length > 0) {
                            ccc.children = [].concat(
                              ccc.children.map((el) => {
                                return Object.assign({}, el);
                              })
                            );
                            for (let xy of ccc.children) {
                              let e = Object.assign(
                                {},
                                this.editedItem.children.find((el) => {
                                  return el.id_pergunta == xy.id_pergunta;
                                })
                              );

                              if (typeof e != "undefined") xy.valor = e.valor;
                            }
                          } else {
                            let el = Object.assign(
                              {},
                              this.editedItem.children.find((el) => {
                                return el.id_pergunta == ccc.id_pergunta;
                              })
                            );

                            if (typeof el != "undefined") ccc.valor = el.valor;
                          }
                        }
                      }
                    } else {
                      let el = Object.assign(
                        {},
                        this.editedItem.children.find((el) => {
                          return el.id_pergunta == cc.id_pergunta;
                        })
                      );

                      if (typeof el != "undefined") cc.valor = el.valor;
                    }
                  }
                } else {
                  if (cc.children && cc.children.length > 0) {
                    cc.children = [].concat(
                      cc.children.map((el) => {
                        return Object.assign({}, el);
                      })
                    );
                    for (let xy of cc.children) {
                      let e = Object.assign(
                        {},
                        this.editedItem.children.find((el) => {
                          return el.id_pergunta == xy.id_pergunta;
                        })
                      );

                      if (typeof e != "undefined") xy.valor = e.valor;
                    }
                  } else {
                    let el = Object.assign(
                      {},
                      this.editedItem.children.find((el) => {
                        return el.id_pergunta == cc.id_pergunta;
                      })
                    );

                    if (typeof el != "undefined") cc.valor = el.valor;
                  }
                }
              }
            } else if (p.pergunta.id_tipo == 2) {
              let el = Object.assign(
                {},
                this.editedItem.children.find((el) => {
                  return el.id_pergunta == p.pergunta.id_pergunta;
                })
              );
              if (typeof el != "undefined" && el.valor) {
                let valor = el.valor.split(";").map((el) => {
                  return Number(el);
                });
                p.pergunta.valor = valor;

                for (let v of valor) {
                  let cc = p.pergunta.children.find((el) => {
                    return el.id_pergunta == Number(v);
                  });
                  await this.changeCheck(p.pergunta, cc, 2, true);

                  if (
                    cc.expansivel &&
                    (cc.id_tipo == 1 || cc.id_tipo == 2 || cc.id_tipo == 4)
                  ) {
                    let e = Object.assign(
                      {},
                      this.editedItem.children.find((el) => {
                        return el.id_pergunta == cc.id_pergunta;
                      })
                    );
                    if (typeof e != "undefined" && e.valor) {
                      let valor = e.valor.split(";").map((e) => {
                        return Number(e);
                      });
                      cc.valor = valor;

                      if (cc.id_tipo == 1) {
                        let e = Object.assign(
                          {},
                          this.editedItem.children.find((el) => {
                            return el.id_pergunta == cc.id_pergunta;
                          })
                        );
                        if (typeof e != "undefined" && e.valor) {
                          let valor = e.valor;
                          let ccc = cc.children.find((el) => {
                            return el.id_pergunta == Number(valor);
                          });
                          this.changeCheck(cc, ccc, 1, true);
                          cc.valor = valor;

                          if (
                            ccc.expansivel &&
                            (ccc.id_tipo == 1 || ccc.id_tipo == 2)
                          ) {
                            let e = Object.assign(
                              {},
                              this.editedItem.children.find((el) => {
                                return el.id_pergunta == ccc.id_pergunta;
                              })
                            );
                            if (typeof e != "undefined" && e.valor) {
                              let valor = e.valor.split(";").map((e) => {
                                return Number(e);
                              });
                              ccc.valor = valor;

                              if (ccc.id_tipo == 1) {
                                let e = Object.assign(
                                  {},
                                  this.editedItem.children.find((el) => {
                                    return el.id_pergunta == ccc.id_pergunta;
                                  })
                                );
                                if (typeof e != "undefined" && e.valor) {
                                  let valor = e.valor;
                                  this.changeCheck(
                                    cc,
                                    ccc.children.find((el) => {
                                      return el.id_pergunta == Number(valor);
                                    }),
                                    1,
                                    true
                                  );
                                  ccc.valor = valor;
                                }
                              } else if (ccc.id_tipo == 2) {
                                for (let vv of valor) {
                                  let ccc = ccc.children.find((el) => {
                                    return el.id_pergunta == Number(vv);
                                  });
                                  await this.changeCheck(cc, ccc, 2, true);
                                }
                              }
                            }
                          } else {
                            if (ccc.children && ccc.children.length > 0) {
                              ccc.children = [].concat(
                                ccc.children.map((el) => {
                                  return Object.assign({}, el);
                                })
                              );
                              for (let xy of ccc.children) {
                                let e = Object.assign(
                                  {},
                                  this.editedItem.children.find((el) => {
                                    return el.id_pergunta == xy.id_pergunta;
                                  })
                                );

                                if (typeof e != "undefined") xy.valor = e.valor;
                              }
                            } else {
                              let el = Object.assign(
                                {},
                                this.editedItem.children.find((el) => {
                                  return el.id_pergunta == ccc.id_pergunta;
                                })
                              );

                              if (typeof el != "undefined")
                                ccc.valor = el.valor;
                            }
                          }
                        }
                      } else if (cc.id_tipo == 2) {
                        for (let vv of valor) {
                          let ccc = cc.children.find((el) => {
                            return el.id_pergunta == Number(vv);
                          });

                          await this.changeCheck(cc, ccc, 2, true);
                          if (
                            ccc.expansivel &&
                            (ccc.id_tipo == 1 || ccc.id_tipo == 2)
                          ) {
                            let e = Object.assign(
                              {},
                              this.editedItem.children.find((el) => {
                                return el.id_pergunta == ccc.id_pergunta;
                              })
                            );

                            if (typeof e != "undefined" && e.valor) {
                              let valor = e.valor.split(";").map((e) => {
                                return Number(e);
                              });
                              ccc.valor = valor;

                              if (ccc.id_tipo == 1) {
                                let e = Object.assign(
                                  {},
                                  this.editedItem.children.find((el) => {
                                    return el.id_pergunta == ccc.id_pergunta;
                                  })
                                );
                                if (typeof e != "undefined" && e.valor) {
                                  let valor = e.valor;
                                  this.changeCheck(
                                    cc,
                                    ccc.children.find((el) => {
                                      return el.id_pergunta == Number(valor);
                                    }),
                                    1,
                                    true
                                  );
                                  ccc.valor = valor;
                                }
                              } else if (ccc.id_tipo == 2) {
                                for (let vv of valor) {
                                  let ccc = ccc.children.find((el) => {
                                    return el.id_pergunta == Number(vv);
                                  });
                                  await this.changeCheck(cc, ccc, 2, true);
                                }
                              }
                            }
                          } else {
                            if (ccc.children && ccc.children.length > 0) {
                              ccc.children = [].concat(
                                ccc.children.map((el) => {
                                  return Object.assign({}, el);
                                })
                              );
                              for (let xy of ccc.children) {
                                let e = Object.assign(
                                  {},
                                  this.editedItem.children.find((el) => {
                                    return el.id_pergunta == xy.id_pergunta;
                                  })
                                );

                                if (typeof e != "undefined") xy.valor = e.valor;
                              }
                            } else {
                              let el = Object.assign(
                                {},
                                this.editedItem.children.find((el) => {
                                  return el.id_pergunta == ccc.id_pergunta;
                                })
                              );

                              if (typeof el != "undefined")
                                ccc.valor = el.valor;
                            }
                          }
                        }
                      } else {
                        let el = Object.assign(
                          {},
                          this.editedItem.children.find((el) => {
                            return el.id_pergunta == cc.id_pergunta;
                          })
                        );

                        if (typeof el != "undefined") cc.valor = el.valor;
                      }
                    }
                  } else {
                    if (cc.children && cc.children.length > 0) {
                      cc.children = [].concat(
                        cc.children.map((el) => {
                          return Object.assign({}, el);
                        })
                      );
                      for (let xy of cc.children) {
                        let e = Object.assign(
                          {},
                          this.editedItem.children.find((el) => {
                            return el.id_pergunta == xy.id_pergunta;
                          })
                        );

                        if (typeof e != "undefined") xy.valor = e.valor;
                      }
                    } else {
                      let el = Object.assign(
                        {},
                        this.editedItem.children.find((el) => {
                          return el.id_pergunta == cc.id_pergunta;
                        })
                      );

                      if (typeof el != "undefined") cc.valor = el.valor;
                    }
                  }
                }
              }
            } else {
              let el = Object.assign(
                {},
                this.editedItem.children.find((el) => {
                  return el.id_pergunta == p.pergunta.id_pergunta;
                })
              );

              if (typeof el != "undefined") p.pergunta.valor = el.valor;
            }
          }
        }

        if (pdf) {
          let aux = [];
          let i = 0;
          for (let f of array.sort((a, b) => {
            return a.pergunta.ordem - b.pergunta.ordem;
          })) {
            i++;

            if (
              aux.findIndex((el) => {
                return el.key == f.pergunta.id_dimensao;
              }) == -1
            )
              aux.push({
                key: f.pergunta.id_dimensao,
                name: this.getDimensaoById(f.pergunta.id_dimensao).nome,
                children: [f],
              });
            else
              Object.assign(
                {},
                aux.find((el) => {
                  return el.key == f.pergunta.id_dimensao;
                })
              ).children.push(f);

            if (i == array.length) {
              this.exportarPdf(aux);
            }
          }
        } else {
          let aux = [];

          for (let f of array.sort((a, b) => {
            return a.pergunta.ordem - b.pergunta.ordem;
          })) {
            if (
              aux.findIndex((el) => {
                return el.key == f.pergunta.id_dimensao;
              }) == -1
            )
              aux.push({
                key: f.pergunta.id_dimensao,
                name: this.getDimensaoById(f.pergunta.id_dimensao).nome,
                children: [f],
              });
            else
              Object.assign(
                {},
                aux.find((el) => {
                  return el.key == f.pergunta.id_dimensao;
                })
              ).children.push(f);
          }

          this.formulario = aux;
          this.generating = false;
          this.reporteM = true;
        }

        this.waiting = false;
      });
    },

    exportarPdf(array) {
      this.generating = false;
      var nome = Date.now();

      this.$store
        .dispatch("propostas/export", {
          nome: nome,
          planificacao: {
            instituicao: this.getInstituicaoById(this.editedItem.id_instituicao)
              .nome,
            ano: this.getAnoById(this.editedItem.id_ano).nome,
            acao: this.getAcaoById(this.editedItem.id_acao).nome,
            medida: this.getMedidaById(this.editedItem.id_medida).nome,
            objetivo: this.getObjetivoById(this.editedItem.id_objetivo).nome,
            quem: this.editedItem.quem,
            descricao: this.editedItem.descricao,
            design_acao: this.editedItem.design_acao,
            design_proj: this.editedItem.design_proj,
            descricao: this.editedItem.descricao,
            submetida: this.editedItem.submetida ? "Sim" : "Não",
            reporte: this.editedItem.reporte ? "Sim" : "Não",
            data_submetida: this.editedItem.data_submetida
              ? this.editedItem.data_submetida
              : "-",
            data_reporte: this.editedItem.data_reporte
              ? this.editedItem.data_reporte
              : "-",
          },
          reporte: array,
        })
        .then((res) => {
          if (res) {
            window.open(
              process.env.API_IP + "/enedapi/client/files/" + nome + ".pdf"
            );

            this.generating = false;
            this.toast("success", "Listagem criada com sucesso");
          } else {
            this.generating = false;
            this.toast("error", "Ocorreu um erro na pesquisa.");
          }
        })
        .catch((err) => {
          this.generating = false;
          this.toast("error", "Ocorreu um erro na pesquisa.");
        });
    },

    forceUpdate() {
      this.$forceUpdate();
    },

    changeCheck(pergunta, child, type, ini = false) {
      if (typeof pergunta == "undefined") return;

      if (type == 1) {
        if (ini) child.checked = true;
        else {
          if (child.checked) {
            for (var p of pergunta.children) {
              if (p.id_pergunta != child.id_pergunta) p.checked = false;
            }

            pergunta.valor = child.id_pergunta;
          } else {
            child.checked = false;
            pergunta.valor = null;

            if (child.children && child.children.length) {
              for (var p of child.children) {
                p.checked = false;
              }
            }
          }
        }
      } else if (type == 2) {
        pergunta.valor =
          typeof pergunta.valor == "undefined" ? [] : pergunta.valor;

        if (ini) child.checked = true;
        else {
          if (
            pergunta.valor.findIndex((el) => {
              return el == child.id_pergunta;
            }) > -1
          )
            pergunta.valor.splice(
              pergunta.valor.findIndex((el) => {
                return el == child.id_pergunta;
              }),
              1
            );
          else pergunta.valor.push(child.id_pergunta);

          if (!child.checked) {
            if (child.children && child.children.length) {
              for (var p of child.children) {
                p.checked = false;
              }
            }
          }
        }
      }

      this.forceUpdate();
    },

    checkedPerguntaCompleted(item) {
      var aux = [];

      if (typeof item != "undefined" && item.hasOwnProperty("children")) {
        for (var pergunta of item.children) {
          if (pergunta.pergunta.id_tipo == 5) {
            for (var c of pergunta.pergunta.children) {
              if (c.required) {
                if (!c.hasOwnProperty("valor")) aux.push(false);
                else {
                  if (c.id_tipo == 2) aux.push(c.valor.length > 0);
                  else if (!c.valor) aux.push(false);
                }
              }
            }
          } else {
            if (pergunta.pergunta.required) {
              if (!pergunta.pergunta.hasOwnProperty("valor")) aux.push(false);
              else {
                if (pergunta.pergunta.id_tipo == 2)
                  aux.push(pergunta.pergunta.valor.length > 0);
                else if (!pergunta.pergunta.valor) aux.push(false);
              }
            }
          }
        }

        return aux.findIndex((el) => {
          return el == false;
        }) == -1
          ? true
          : false;
      } else return false;
    },

    getLegenda(tipo) {
      switch (tipo) {
        case 1:
          return "Apenas uma opção";
          break;
        case 2:
          return "Várias opções";
          break;

        case 3:
          return "Campo de texto aberto";
          break;

        case 4:
          return "Campo numérico";
          break;

        case 5:
          return "Pergunta com vários níveis";
          break;

        case 6:
          return "Seleção de distrito";
          break;

        case 7:
          return "Seleção de setor";
          break;

        case 8:
          return "Campo de texto longo";
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
.parent {
  background-color: #f5f5f5 !important;
}

.label-pergunta {
  font-size: 20px !important;
}

.label-nivel {
  font-size: 17px !important;
}

.child-1 {
  margin-left: 30px !important;
}

.child-2 {
  margin-left: 60px !important;
}

.child-3 {
  margin-left: 90px !important;
}

.child-4 {
  margin-left: 120px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tables/Table_Propostas_Admin.vue